import { Environment } from '../environments';
import { buildBiwApiRootUri } from './buildBiwApiRootUri';
import { buildUri } from './utils/buildUri';

const CMX_SERVICE_PATH = '/v2/cmx';

export const buildCmxServiceUri = ( env ) => (
    buildUri(
        [ buildBiwApiRootUri( env ), CMX_SERVICE_PATH ],
        { env: ( env !== Environment.PROD ) ? env : '' },
    )
);
